import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneActionsRefresh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "phone-actions-refresh" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.169,16.164a2.5,2.5,0,0,0-3.536,0l-.386.385A47.037,47.037,0,0,1,7.458,10.76l.386-.386a2.505,2.505,0,0,0,0-3.535L5.722,4.718a2.558,2.558,0,0,0-3.536,0L1.022,5.881a3.507,3.507,0,0,0-.441,4.4A46.906,46.906,0,0,0,13.722,23.426a3.549,3.549,0,0,0,4.4-.443l1.163-1.163a2.5,2.5,0,0,0,0-3.535Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M23.689.316a.5.5,0,0,0-.545.109L21.672,1.9a6.374,6.374,0,1,0-4.528,10.86,6.346,6.346,0,0,0,4.983-2.4A1,1,0,1,0,20.565,9.11a4.375,4.375,0,1,1-.306-5.8L18.687,4.882a.5.5,0,0,0,.354.853H23.5a.5.5,0,0,0,.5-.5V.778A.5.5,0,0,0,23.689.316Z" })
	]
});
export default SvgPhoneActionsRefresh;
